import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory, useParams } from 'react-router'

import './SubprogramDetail.css'

import MakeHeader from '../ReusableComponents/Header/MakeHeader'
import renderImage from '../../source/importImg'
import getBackendImage from '../../source/imageUtil'
import { EXPANSION_KITS } from '../../utils/expansionKits'

const BACKEND_URL = process.env.REACT_APP_API_BASE

const SubprogramDetail = (props) => {
    const history = useHistory()
    const { subId } = useParams()
    const device = sessionStorage.getItem('allowedDevice') || 'Toki'
    const deviceVersion = sessionStorage.getItem('deviceVersion')?.split('.')?.slice(0, 2)?.join('.') || '1.0'
    const expansionKit = sessionStorage.getItem('expansionKit')

    const [program, setProgram] = useState(null)
    const [subprogram, setSubprogram] = useState(null)

    useEffect(() => {
        // Resolve which board/program this subprogram belongs to (Toki, Poki, …)
        // from the device the learner selected. Hardcoding 'toki' meant Poki
        // subprograms were never found, so the detail page rendered nothing.
        fetch(`${BACKEND_URL}/api/program/${device.toLowerCase()}`)
            .then((res) => res.json())
            .then((data) => {
                setProgram(data)
                const sub = data.subprograms.find((s) => s.id === subId)
                setSubprogram(sub || null)
            })
            .catch((err) => {
                console.error('Failed to load program:', err)
            })
    }, [subId, device])

    const goBack = () => {
        history.push(`/kitMenu?subprogramId=${subId}`)
    }

    const handleStart = () => {
        history.push(`/make/${subId}/run`)
    }

    if (!subprogram) {
        return (
            <div className="SubDetail_Main">
                <div className="Select_Headers">
                    <MakeHeader
                        title={`${device} (v${deviceVersion})`}
                        titlePosition="left"
                        help_btnPosition="right"
                        isGoBack={true}
                        goBack={goBack}
                        showAccountSetting={true}
                        showHelp={true}
                        showBluetoothBtn={true}
                    />
                </div>
                <div
                    className="SubDetail_Body"
                    style={{ justifyContent: 'center', alignItems: 'center' }}
                >
                    <div style={{ fontSize: '1.2vw', color: '#888' }}>
                        {/* Loading... */}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="SubDetail_Main">
            {/* Header */}
            <div className="Select_Headers">
                <MakeHeader
                    title={expansionKit ? `${EXPANSION_KITS[expansionKit]?.name || expansionKit}` : `${device} (v${deviceVersion})`}
                    titlePosition="left"
                    help_btnPosition="right"
                    isGoBack={true}
                    goBack={goBack}
                    showAccountSetting={true}
                    showHelp={true}
                    showBluetoothBtn={true}
                />
            </div>

            {/* Body */}
            <div className="SubDetail_Body">
                {/* LEFT */}
                <div className="SubDetail_Left">
                    <img
                        src={getBackendImage(
                            subprogram.image || 'projectDefault'
                        )}
                        alt={subprogram.title}
                        className="SubDetail_Image"
                    />
                </div>

                {/* RIGHT */}
                <div className="SubDetail_Right">
                    <div className="SubDetail_Title">{subprogram.title}</div>

                    <div className="SubDetail_Description">
                        {subprogram.description.split('\n').map((line, i) => (
                            <p key={i}>{line}</p>
                        ))}

                        {/* <-- NEW CONDITIONAL RENDER FOR THE LINK --> */}
                        {subprogram.link && (
                            <a 
                                href={subprogram.link} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="SubDetail_Link"
                            >
                                Visit Source Link
                            </a>
                        )}
                    </div>

                    <button className="SubDetail_Start" onClick={handleStart}>
                        Start
                    </button>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    languageName: state.device.language,
})

export default connect(mapStateToProps)(SubprogramDetail)
